import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TargetingAdminStore } from '../../stores';
// import ITargetingGroup from '../../../interfaces/ITargetingGroup';
// import { GroupListColumnType, GroupListItem } from '../../../interfaces/IGroupList';
import { IAGroupList } from '../../../groupList/GroupList';
import { IASpinner } from '../../../spinner/Spinner';
import EditPanel from './EditPanel';
import { IAButton } from '../../../button/Button';
import { IAPopup } from '../../../popup/Popup';
import { IACommandBar } from '../../../commandBar/CommandBar';
import { TargetingService } from '../../../../services/TargetingService';
import { Helper } from '../../../../Helper';
import * as styles from './UserGroup.css';
import { LocalizationService } from '../../../../services/LocalizationService';

export interface IUserGroupProps {
  targetingStore?: TargetingAdminStore;
  reloadGroups: () => void;
}

@inject('targetingStore')
@observer
export default class UserGroup extends React.Component<IUserGroupProps> {

  private deletePopupId;
  private cancelPopupId;

  constructor(props, state) {
    super(props, state);
    this.deletePopupId = Helper.getRandomStringKey();
    this.cancelPopupId = Helper.getRandomStringKey();

  }

  public render(): JSX.Element {
    return (
      <div>
        <div>{new LocalizationService().strings.TargetingAdmin_UserGroup_TabText}</div>
        <IACommandBar
          highlightColor={this.props.targetingStore.highlightColor}
          showBar={true}
          leftSideContent={
            <div style={{height: 40}}>
              <IAButton
                label={new LocalizationService().strings.Messages_Add}
                buttonColor="transparent"
                textColor="#333333"
                icon="Add"
                iconColor={this.props.targetingStore.highlightColor}
                fontSize={14}
                height={22}
                style={{ float: "left", marginTop: 5 }}
                dataAutomationId="messages-add-new"
                onClick={() => {
                  this.props.targetingStore.userGroupToEdit = {
                    title: undefined,
                    values: undefined,
                    id: undefined
                  };
                  this.props.targetingStore.originalUserGroupToEdit = Object.assign({}, this.props.targetingStore.userGroupToEdit);
                  this.props.targetingStore.creatingNew = true;
                }}
              />
            </div>
          }
          rightSideContent={<div></div>}
        />
        {this.props.targetingStore.groupedList && !this.props.targetingStore.loading &&
          <IAGroupList
            highlightColor={"#025159"}
            groupsItem={this.props.targetingStore.groupedList}
            getUpdates={(items, selectedItem) => {
              console.log(items);
              const selectedItemUG = this.props.targetingStore.groupsList.filter(x => x.id === selectedItem.id)[0];
              this.props.targetingStore.userGroupToEdit =
              {
                id: selectedItemUG.id,
                title: selectedItemUG.title,
                values: selectedItemUG.values
              };
              this.props.targetingStore.creatingNew = false;
            }} />
        }
        {this.props.targetingStore.loading &&
          <IASpinner />
        }

        <EditPanel reloadGroups={this.props.reloadGroups} />

        {!this.props.targetingStore.loading && this.props.targetingStore.groupsList !== undefined &&
          this.props.targetingStore.groupsList[0] !== undefined && this.props.targetingStore.groupsList[0][0] === undefined &&
          this.props.targetingStore.groupsList.length === 0 &&
          <div className={styles.IA_listViewDivider}>{new LocalizationService().strings.TargetingAdmin_UserGroup_NoGroups}</div>
        }

        <div id={`deletePopupId_${this.deletePopupId}`}>
          {this.props.targetingStore.userGroupToDelete !== undefined &&
            <IAPopup
              headline={new LocalizationService().strings.DeletePopup_Headline}
              content={
                <div>
                  <div
                    style={{
                      float: "left"
                    }}
                  >
                    {new LocalizationService().strings.DeletePopup_Message}
                  </div>
                  <div
                    style={{
                      clear: "both",
                      float: "left"
                    }}
                  >
                    <IAButton
                      label={new LocalizationService().strings.DeletePopup_Yes}
                      buttonColor={this.props.targetingStore.highlightColor}
                      showSpinner={false}
                      onClick={() => {
                        TargetingService.deleteGroup(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token, this.props.targetingStore.userGroupToDelete.id).then(() => {
                          this.props.targetingStore.userGroupToEdit = undefined;
                          this.props.targetingStore.userGroupToDelete = undefined;
                          this.props.reloadGroups();
                        });
                      }}
                      style={{
                        marginTop: 20,
                        float: "left"
                      }}
                    />
                    <IAButton
                      label={new LocalizationService().strings.DeletePopup_No}
                      buttonColor={"#999999"}
                      showSpinner={false}
                      onClick={() => {
                        this.props.targetingStore.userGroupToDelete = undefined;
                      }}
                      style={{
                        marginTop: 20,
                        marginLeft: 10,
                        float: "left"
                      }}
                    />
                  </div>
                </div>
              }
              close={() => {
                this.props.targetingStore.userGroupToDelete = undefined;
              }}
            />
          }
        </div>

        <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.props.targetingStore.showCancelEditPopup &&
            <IAPopup
              headline={new LocalizationService().strings.CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={new LocalizationService().strings.CancelPopup_Yes}
                    buttonColor={this.props.targetingStore.highlightColor}
                    showSpinner={false}
                    onClick={() => {
                      this.props.targetingStore.userGroupToEdit = undefined;
                      this.props.targetingStore.originalUserGroupToEdit = undefined;
                      this.props.targetingStore.creatingNew = false;
                      this.props.targetingStore.showCancelEditPopup = false;
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={new LocalizationService().strings.CancelPopup_No}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.targetingStore.showCancelEditPopup = false;
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.targetingStore.showCancelEditPopup = false;
              }}
            />
          }
        </div>

      </div>
    );
  }
}